import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';


class Checkboxes extends React.Component {
    static propTypes = {
        checkboxes: PropTypes.arrayOf(PropTypes.shape({
            error: PropTypes.string,
            label: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
            touched: PropTypes.bool,
            checked: PropTypes.bool.isRequired,
        })).isRequired,
        cssClass: PropTypes.string,
        label: PropTypes.string,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        cssClass: null,
        label: null,
        onBlur: () => {},
        onChange: () => {},
        disabled: false,
    };

    renderCheckboxes() {
        return this.props.checkboxes.map((checkbox) => {
            const touchedError = checkbox.touched && checkbox.error;
            const formControlClasses = classnames('form-check-input', {'is-invalid': touchedError});
            return (
                <div className="form-check" key={checkbox.name}>
                    <input
                        name={checkbox.name}
                        id={checkbox.name}
                        type="checkbox"
                        className={formControlClasses}
                        checked={checkbox.checked}
                        onBlur={this.props.onBlur}
                        onChange={this.props.onChange}
                        disabled={this.props.disabled}
                    />
                    <label className="form-check-label" htmlFor={checkbox.name}>{checkbox.label}</label>
                    {touchedError && <div className="invalid-feedback">{touchedError}</div>}
                </div>
            );
        });
    }

    render() {
        const formGroupClasses = classnames('form-group', this.props.cssClass);
        return (
            <div className={formGroupClasses}>
                {this.props.label ? <div className="mb-1">{this.props.label}</div> : null}
                {this.renderCheckboxes()}
            </div>
        );
    }
}

export default Checkboxes;



// WEBPACK FOOTER //
// ./src/components/Checkboxes.js